import apiMiddleware from "../../../api/apiMiddleware";


//*******************************************************************************
// ATTRACTION LISTING & SEARCH SERVICES
//*******************************************************************************

export const list = async (page = 1, search = "", filter = "") => {
  let url = `/attraction-list-admin?page=${page}&include=category`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (filter) url += `&category=${encodeURIComponent(filter)}`;
  const response = await apiMiddleware.get(url);


  // The real array is in response.data.data.data
  const pagination = response.data?.data || {};
  return {
    data: pagination.data || [],
    current_page: pagination.current_page || 1,
    last_page: pagination.last_page || 1,
    total: pagination.total || 0,
    per_page: pagination.per_page || 10
  };
};

 

export const getAttractionById = async (id) => {
  return await apiMiddleware.get(`/attractions-general-info/${id}`);
};

export const changeAttractionName = async (id, name) => {
  return await apiMiddleware.put(`/attractions-general-info/${id}/name`, { name });
};

export const deleteAttraction = async (id) => {
  return await apiMiddleware.delete(`/attractions-general-info/${id}`);
};

//*******************************************************************************
// GENERAL INFO TAB SERVICES
//*******************************************************************************

export const getAttractionCategories = async () => {
  const response = await apiMiddleware.get("/active-attraction-categories");
  return response.data;
};

export const createAttraction = async (data) => {
  const response = await apiMiddleware.post("/attractions-general-info", data);
  return response;
};

export const updateAttraction = async (id, data) => {
  return await apiMiddleware.post(`/attractions-general-info/${id}?_method=PUT`, data);
};

export const deleteAttractionImages = async (imageId) => {
  return await apiMiddleware.delete(`/attractions-general-info/images/${imageId}`);
};

// Attraction Settings
export const attractionSettings = async (attractionId, data) => {
  const response = await apiMiddleware.put(`/attraction-settings/${attractionId}`, data);
  return response.data;
};

//*******************************************************************************
// PRICING TAB SERVICES
//*******************************************************************************

export const getAttractionSeasons = async (attraction_id) => {
  const response = await apiMiddleware.get(`/attraction-seasons/${attraction_id}`);
  return response.data.data;
};

export const getTicketTypesUnderAttraction = async (attraction_id) => { 
  const response = await apiMiddleware.get(`/attraction-ticket-types/${attraction_id}`); 
  return response.data.data;
};

export const saveSeason = async (data) => {
  // Validate required fields
  if (!data.attraction_id || !data.attraction_season_id) {
    throw new Error("attraction_id and attraction_season_id are required");
  }

  // Structure the data according to API requirements
  const requestData = {
    attraction_id: data.attraction_id,
    attraction_season_id: data.attraction_season_id,
    ticketPrice: data.ticketPrice || [] // Array of {price, available_slots, description, max_allowed_booking_per_user, discount, attraction_ticket_type_id}
  };

  console.log("Saving season data:", requestData);
  
  const response = await apiMiddleware.post("/add-attraction-pricing", requestData);
  return response;
};


export const updateSeason = async (data) => {
  const response = await apiMiddleware.post(`/update-attraction-pricing?_method=PUT`, data);
  return response;
};

export const getAttractionPricing = async (attractionId) => {
    // Call with attraction_id parameter
    const response = await apiMiddleware.get(`/attraction-pricing/${attractionId}`);
    return response.data.data;
 
};

export const attractionPricingContinue = async (data) => {
  const response = await apiMiddleware.post('/attraction-pricing-save-and-continue', data);
  return response;
};

//*******************************************************************************
// HIGHLIGHTS TAB SERVICES
//*******************************************************************************


export const saveAttractionHighlights = async (data) => {
  const response = await apiMiddleware.post(`/attraction-highlights`, data);
  return response.data;
};


export const getAttractionHighlights = async (attractionId) => {
  const response = await apiMiddleware.get(`/attraction-highlights/${attractionId}`);
  return response.data;
};


export const updateAttractionHighlights = async (data) => {
  const response = await apiMiddleware.post(
    `/attraction-highlights?_method=PUT`,
    data
  );
  return response.data;
};

export const deleteAttractionHighlights = async (highlight_id) => {
  const response = await apiMiddleware.delete(`/attraction-highlights/${highlight_id}`);
  return response.data;
};

//*******************************************************************************
// FAQ TAB SERVICES
//*******************************************************************************

export const getAttractionFAQ = async (attractionId) => {
  const response = await apiMiddleware.get(`/attraction-faqs/${attractionId}`);
  return response;
};

export const createAttractionFAQ = async (data) => {
  const response = await apiMiddleware.post(`/attraction-faqs`, data);
  return response;
};

export const updateAttractionFAQ = async (attractionId, data) => {
  const response = await apiMiddleware.post(`/attraction-faqs/${attractionId}?_method=PUT`, data);
  return response;
};

export const deleteAttractionFAQ = async (attractionId) => {
  const response = await apiMiddleware.delete(`/attraction-faqs/${attractionId}`);
  return response;
};

// Alternative FAQ service names (used in some components)
export const getAttractionFaq = async (attractionId) => {
  const response = await apiMiddleware.get(`/attraction-faqs/${attractionId}`);
  return response;
};

export const deleteAttractionFaq = async (faqId) => {
  const response = await apiMiddleware.delete(`/attraction-faq/${faqId}`);
  return response;
};

//*******************************************************************************
// TERMS & CONDITIONS TAB SERVICES
//*******************************************************************************

export const getAttractionTermsAndConditions = async (attractionId) => {
  const specificResponse = await apiMiddleware.get(`/attraction-terms-and-conditions-by-attraction/${attractionId}`);
  return specificResponse;
};

export const saveAttractionTermsAndConditions = async (data) => {
    // Use the resource POST endpoint
    const response = await apiMiddleware.post('/attraction-terms-and-conditions', data);
    return response.data.data;
};

export const updateAttractionTermsAndConditions = async (attractionId, data) => {
  const response = await apiMiddleware.put(`/attraction-terms-and-conditions/${attractionId}`, data);
  return response.data.data;
};
